// Ð¢ÐµÐºÑÑÑ Ð¾Ð±ÑÑÐµÐ½Ð¸Ñ. ÐÐ´Ð¸Ð½ ÑÐ°Ð¹Ð» Ð½Ð° ÑÐ·ÑÐº â ÑÑÐ¾Ð±Ñ Ð¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ð¸ÑÐ¾Ð²ÐºÐ¸ Ð¸ Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð¸ÑÑ,
// Ð½Ðµ ÑÑÐ¾Ð³Ð°Ñ ÐºÐ¾Ð´ ÑÐ°Ð³Ð¾Ð² (onboardingSteps.js ÑÑÑÐ»Ð°ÐµÑÑÑ ÑÑÐ´Ð° Ð¿Ð¾ ÐºÐ»ÑÑÐ°Ð¼).
//
// ÐÑÐ°Ð²Ð¸Ð»Ð° Ð´Ð»Ñ ÑÐµÐºÑÑÐ¾Ð²:
//   â ÐºÐ¾ÑÐ¾ÑÐºÐ¾ Ð¸ Ð¿ÑÐ¾ÑÑÑÐ¼ ÑÐ·ÑÐºÐ¾Ð¼, Ð±ÐµÐ· Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¸Ñ ÑÐµÑÐ¼Ð¸Ð½Ð¾Ð²;
//   â Ð½Ðµ Ð¾Ð±ÐµÑÐ°ÐµÐ¼ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¸ Ð½Ðµ Ð½Ð°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÑÐ°Ð²ÐºÐ¸: ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ Ð±Ð°Ð½Ðº;
//   â Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº Ð´Ð¾ 40 Ð·Ð½Ð°ÐºÐ¾Ð², ÑÐµÐºÑÑ â Ð¾Ð´Ð½Ð¾-Ð´Ð²Ð° Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ.

const ru = {
  ui: {
    next: 'ÐÐ°Ð»ÐµÐµ',
    back: 'ÐÐ°Ð·Ð°Ð´',
    skip: 'ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ',
    finish: 'ÐÐ¾ÑÐ¾Ð²Ð¾',
    close: 'ÐÐ°ÐºÑÑÑÑ Ð¾Ð±ÑÑÐµÐ½Ð¸Ðµ',
    stepOf: (current, total) => `${current} Ð¸Ð· ${total}`,
    restart: 'ÐÑÐ¾Ð¹ÑÐ¸ Ð¾Ð±ÑÑÐµÐ½Ð¸Ðµ Ð·Ð°Ð½Ð¾Ð²Ð¾',
    whereToFind: 'ÐÐ±ÑÑÐµÐ½Ð¸Ðµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð¹ÑÐ¸ Ð² Ð»ÑÐ±Ð¾Ð¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ â ÐºÐ½Ð¾Ð¿ÐºÐ° Â«ÐÑÐ¾Ð¹ÑÐ¸ Ð¾Ð±ÑÑÐµÐ½Ð¸Ðµ Ð·Ð°Ð½Ð¾Ð²Ð¾Â» Ð²Ð½Ð¸Ð·Ñ Ð¼ÐµÐ½Ñ.',
  },

  steps: {
    welcome: {
      title: 'ÐÐ¾Ð±ÑÐ¾ Ð¿Ð¾Ð¶Ð°Ð»Ð¾Ð²Ð°ÑÑ',
      text: 'Ð­ÑÐ¾ ÑÐ°Ð±Ð¾ÑÐµÐµ Ð¼ÐµÑÑÐ¾ ÐºÑÐµÐ´Ð¸ÑÐ½Ð¾Ð³Ð¾ Ð±ÑÐ¾ÐºÐµÑÐ°. ÐÐ´ÐµÑÑ Ð²Ñ Ð·Ð°Ð²Ð¾Ð´Ð¸ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°, ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑÐµ ÑÐ´ÐµÐ»ÐºÑ Ð¸ Ð¾Ð´Ð½Ð¾Ð¹ Ð°Ð½ÐºÐµÑÐ¾Ð¹ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÑÐµ Ð·Ð°ÑÐ²ÐºÑ ÑÑÐ°Ð·Ñ Ð² Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð±Ð°Ð½ÐºÐ¾Ð².',
    },
    sidebar: {
      title: 'Ð Ð°Ð·Ð´ÐµÐ»Ñ',
      text: 'Ð¡Ð»ÐµÐ²Ð° â Ð²ÑÐµ ÑÐ°Ð·Ð´ÐµÐ»Ñ: ÐºÐ»Ð¸ÐµÐ½ÑÑ, Ð»Ð¸Ð´Ñ, Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸, Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸ Ð¸ Ð¾ÑÑÑÑÑ. ÐÐ°Ð±Ð¾Ñ Ð¿ÑÐ½ÐºÑÐ¾Ð² Ð·Ð°Ð²Ð¸ÑÐ¸Ñ Ð¾Ñ Ð²Ð°ÑÐ¸Ñ Ð¿ÑÐ°Ð².',
    },
    clients: {
      title: 'ÐÐ»Ð¸ÐµÐ½ÑÑ',
      text: 'ÐÑÐºÑÑÐ»Ð¸ ÐºÐ°ÑÑÐ¾ÑÐµÐºÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð² ÑÐ°Ð»Ð¾Ð½Ð°. Ð¡ Ð½ÐµÑ Ð½Ð°ÑÐ¸Ð½Ð°ÐµÑÑÑ Ð»ÑÐ±Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°: ÑÐ½Ð°ÑÐ°Ð»Ð° Ð½Ð°ÑÐ¾Ð´Ð¸Ð¼ ÐºÐ»Ð¸ÐµÐ½ÑÐ°, Ð° ÐµÑÐ»Ð¸ ÐµÐ³Ð¾ Ð½ÐµÑ â Ð·Ð°Ð²Ð¾Ð´Ð¸Ð¼.',
    },
    addClient: {
      title: 'ÐÐ¾Ð²ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½Ñ',
      text: 'ÐÐ½Ð¾Ð¿ÐºÐ° Ð·Ð°Ð²Ð¾Ð´Ð¸Ñ ÐºÐ°ÑÑÐ¾ÑÐºÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°. ÐÐ°Ð½Ð½ÑÐµ Ð¿Ð¾Ð´ÑÑÐ³Ð¸Ð²Ð°ÑÑÑÑ Ð¿Ð¾ ÐÐÐ, Ð¾ÑÑÐ°Ð½ÐµÑÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ Ð¸ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÑ.',
    },
    search: {
      title: 'ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº',
      text: 'ÐÐ¾Ð¸ÑÐº ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ Ð¿Ð¾ Ð¸Ð¼ÐµÐ½Ð¸, ÑÐµÐ»ÐµÑÐ¾Ð½Ñ Ð¸ ÐÐÐ. Ð¢Ð°Ðº Ð¶Ðµ Ð¾Ð½ ÑÑÑÑÐ¾ÐµÐ½ Ð² Ð»ÑÐ±Ð¾Ð¼ Ð´ÑÑÐ³Ð¾Ð¼ ÑÐ¿Ð¸ÑÐºÐµ.',
    },
    filters: {
      title: 'ÐÑÐ±Ð¾Ñ Ð¿Ð¾ ÑÑÐ»Ð¾Ð²Ð¸ÑÐ¼',
      text: 'Ð Ð°ÑÑÐ¸ÑÐµÐ½Ð½ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¾ÑÐ±Ð¸ÑÐ°ÐµÑ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð¿Ð¾ ÑÑÐ°ÑÑÑÑ, Ð´Ð°ÑÐµ, Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¸ Ð´ÑÑÐ³Ð¸Ð¼ Ð¿Ð¾Ð»ÑÐ¼. ÐÑÐ±ÑÐ°Ð½Ð½ÑÐµ ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð²Ð¸Ð´Ð½Ð¾ ÑÑÑÐ¾ÐºÐ¾Ð¹ Ð¿Ð¾Ð´ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹.',
    },
    leads: {
      title: 'ÐÐ¸Ð´Ñ',
      text: 'Ð­ÑÐ¾ ÑÐ°Ð·Ð´ÐµÐ» Ð»Ð¸Ð´Ð¾Ð² â ÑÑÐ´Ð° Ð¿Ð°Ð´Ð°ÑÑ Ð¾Ð±ÑÐ°ÑÐµÐ½Ð¸Ñ Ð¸Ð· Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ Ð¸ Ñ Halyk Market. ÐÐ¸Ð´ Ð½ÑÐ¶Ð½Ð¾ Ð²Ð·ÑÑÑ Ð² ÑÐ°Ð±Ð¾ÑÑ Ð¸ Ð´Ð¾Ð²ÐµÑÑÐ¸ Ð´Ð¾ ÑÐ´ÐµÐ»ÐºÐ¸, Ð° ÐµÑÐ»Ð¸ ÑÐ´ÐµÐ»ÐºÐ° Ð¿Ð¾ Ð½ÐµÐ¼Ñ ÑÐ¶Ðµ ÑÐ¾Ð·Ð´Ð°Ð½Ð° â Ð¾ÑÑÐ°Ð±Ð¾ÑÐ°ÑÑ ÐµÑ Ð´Ð¾ ÐºÐ¾Ð½ÑÐ°.',
    },
    deals: {
      title: 'ÐÑÐ¾Ð´Ð°Ð¶Ð¸',
      text: 'Ð­ÑÐ¾ Ð²Ð°ÑÐ¸ ÑÐ´ÐµÐ»ÐºÐ¸ Ð¿Ð¾ Ð½Ð¾Ð²ÑÐ¼ Ð¸ ÐÐ£ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÐ¼. Ð¡ÑÐ´Ð° Ð¶Ðµ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÑÑ ÑÐ´ÐµÐ»ÐºÐ¸ Ñ Halyk Market â ÐºÐ»Ð¸ÐµÐ½Ñ Ð¾ÑÑÐ°Ð²Ð¸Ð» Ð·Ð°ÑÐ²ÐºÑ Ð½Ð° Ð¿Ð»Ð¾ÑÐ°Ð´ÐºÐµ Ð¸ Ð±Ð°Ð½Ðº ÐµÑ Ð¾Ð´Ð¾Ð±ÑÐ¸Ð». ÐÐ½ÑÑÑÐ¸ ÑÐ´ÐµÐ»ÐºÐ¸ ÑÐ¾Ð±Ð¸ÑÐ°ÑÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ, Ð´Ð¾Ð¿Ñ Ð¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°.',
    },
    cars: {
      title: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸',
      text: 'ÐÐµÑÑ Ð°Ð²ÑÐ¾Ð¿Ð°ÑÐº ÑÐ°Ð»Ð¾Ð½Ð°: Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ, ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸, ÑÐµÐ½Ñ Ð¸ VIN. ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ Ð¿Ð¾Ð»Ð½Ð¾Ð¼Ñ VIN Ð½Ð°ÑÐ¾Ð´Ð¸Ñ Ð¼Ð°ÑÐ¸Ð½Ñ Ð² Ð»ÑÐ±Ð¾Ð¼ Ð³Ð¾ÑÐ¾Ð´Ðµ, Ð´Ð°Ð¶Ðµ ÐµÑÐ»Ð¸ Ð¾Ð½Ð° ÑÑÐ¾Ð¸Ñ Ð² Ð´ÑÑÐ³Ð¾Ð¼.',
    },
    createDeal: {
      title: 'ÐÐ°Ðº ÑÐ¾Ð·Ð´Ð°ÑÑ ÑÐ´ÐµÐ»ÐºÑ',
      text: 'Ð¡Ð´ÐµÐ»ÐºÐ° Ð½Ð°ÑÐ¸Ð½Ð°ÐµÑÑÑ Ð¾ÑÑÑÐ´Ð°, ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Â«ÐÑÐ¾Ð´Ð°ÑÑ Ð°Ð²ÑÐ¾Â»: Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¸ Ð¼Ð°ÑÐ¸Ð½Ñ, Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑÐµ Ðº Ð½ÐµÐ¹ Ð´Ð¾Ð¿Ñ Ð¸ Ð°ÐºÑÐµÑÑÑÐ°ÑÑ, ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð¸ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÑÐµ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½ÐºÐ¸.',
    },
    addCar: {
      title: 'ÐÐ¾Ð²ÑÐ¹ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
      text: 'ÐÐ°ÑÐ¸Ð½Ñ Ð¿ÑÐ¸ÐµÐ·Ð¶Ð°ÑÑ Ð¸Ð· ÑÑÐ¾ÐºÐ° ÑÐ°Ð¼Ð¸, Ð½Ð¾ Ð»ÑÐ±ÑÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð·Ð°Ð²ÐµÑÑÐ¸ ÑÑÐºÐ°Ð¼Ð¸ â ÑÑÐ¾Ð¹ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹. ÐÐ¾Ð½Ð°Ð´Ð¾Ð±Ð¸ÑÑÑ, ÐºÐ¾Ð³Ð´Ð° Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÑÐ¾ÐºÐµ ÐµÑÑ Ð½ÐµÑ, Ð° ÑÐ´ÐµÐ»ÐºÑ Ð¾ÑÐ¾ÑÐ¼Ð»ÑÑÑ ÑÐ¶Ðµ Ð¿Ð¾ÑÐ°.',
    },
    credit: {
      title: 'ÐÐ°ÑÐ²ÐºÐ° Ð² Ð±Ð°Ð½ÐºÐ¸',
      text: 'ÐÐ½ÐºÐµÑÐ° Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÐµÑÑÑ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð· Ð¸ ÑÑÐ¾Ð´Ð¸Ñ Ð² Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð±Ð°Ð½ÐºÐ¾Ð² ÑÑÐ°Ð·Ñ. Ð¡ÑÐ¼Ð¼Ñ Ð¸ Ð¿Ð»Ð°ÑÑÐ¶ Ð² ÑÐ´ÐµÐ»ÐºÐµ â Ð½Ð°Ñ ÑÐ°ÑÑÑÑ: Ð¿ÑÐµÐ¶Ð´Ðµ ÑÐµÐ¼ Ð½Ð°Ð·ÑÐ²Ð°ÑÑ Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÑ, ÑÐ²ÐµÑÑÑÐµÑÑ Ñ ÐºÐ°Ð»ÑÐºÑÐ»ÑÑÐ¾ÑÐ¾Ð¼ Ð±Ð°Ð½ÐºÐ°. ÐÑÐ¾Ð³Ð¾Ð²ÑÐµ ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ Ð±Ð°Ð½Ðº.',
    },
    decisions: {
      title: 'Ð ÐµÑÐµÐ½Ð¸Ñ Ð±Ð°Ð½ÐºÐ¾Ð²',
      text: 'ÐÑÐ²ÐµÑÑ Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð²Ð¾ Ð²ÐºÐ»Ð°Ð´ÐºÑ Â«ÐÑÐµÐ´Ð¸ÑÂ» Ð¿Ð¾ Ð¼ÐµÑÐµ Ð³Ð¾ÑÐ¾Ð²Ð½Ð¾ÑÑÐ¸. Ð¢Ð°Ð¼ Ð¶Ðµ Ð²Ð¸Ð´Ð½Ð¾, ÐºÐ°ÐºÐ¾Ð¹ Ð±Ð°Ð½Ðº ÑÑÐ¾ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶Ð¸Ð» Ð¸ ÑÐµÐ³Ð¾ ÐµÑÑ Ð¶Ð´ÑÐ¼.',
    },
    profile: {
      title: 'ÐÐ°Ñ Ð¿ÑÐ¾ÑÐ¸Ð»Ñ',
      text: 'ÐÐ´ÐµÑÑ Ð²Ð¸Ð´Ð½Ð¾ Ð²Ð°Ñ Ð°Ð²ÑÐ¾ÑÐ°Ð»Ð¾Ð½, ÑÐ¾Ð»Ñ Ð¸ ÑÐµÐ³Ð¸Ð¾Ð½ â Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ, ÑÑÐ¾ Ð²ÑÑ Ð²ÐµÑÐ½Ð¾. ÐÑÐ»Ð¸ Ð´Ð°Ð½Ð½ÑÐµ Ð½Ðµ ÑÐµ, Ð½Ð°Ð¿Ð¸ÑÐ¸ÑÐµ Ð² ÑÐµÑÐ¿Ð¾Ð´Ð´ÐµÑÐ¶ÐºÑ: Ð¾Ñ Ð½Ð¸Ñ Ð·Ð°Ð²Ð¸ÑÐ¸Ñ, ÐºÐ°ÐºÐ¸Ðµ Ð¼Ð°ÑÐ¸Ð½Ñ Ð¸ ÑÐ´ÐµÐ»ÐºÐ¸ Ð²Ñ Ð²Ð¸Ð´Ð¸ÑÐµ.',
    },
    help: {
      title: 'ÐÑÐ»Ð¸ ÑÑÐ¾-ÑÐ¾ Ð½Ðµ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ',
      text: 'ÐÐ½Ð¾Ð¿ÐºÐ° Â«ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸ÐµÂ» Ð²Ð½Ð¸Ð·Ñ Ð¼ÐµÐ½Ñ ÑÐºÐ°Ð¶ÐµÑ, Ð²Ð¸Ð´Ð¸Ñ Ð»Ð¸ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð° ÑÐµÑÐ²ÐµÑ. ÐÑÐ»Ð¸ ÑÐ²ÑÐ·Ñ ÐµÑÑÑ, Ð° ÑÑÐ¾-ÑÐ¾ Ð½Ðµ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ â Ð½Ð°Ð¿Ð¸ÑÐ¸ÑÐµ Ð² ÑÐµÑÐ¿Ð¾Ð´Ð´ÐµÑÐ¶ÐºÑ.',
    },
  },

  checklist: {
    title: 'ÐÐµÑÐ²ÑÐµ ÑÐ°Ð³Ð¸',
    subtitle: 'ÐÑÐ¾Ð¹Ð´Ð¸ÑÐµ Ð¿ÑÑÑ Ð´Ð¾ Ð¿ÐµÑÐ²Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐ¸',
    hide: 'Ð¡ÐºÑÑÑÑ',
    done: 'ÐÐ¾ÑÐ¾Ð²Ð¾! Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼.',
    items: {
      profile: 'ÐÐ°Ð³Ð»ÑÐ½ÑÑÑ Ð² Ð¿ÑÐ¾ÑÐ¸Ð»Ñ',
      client: 'ÐÐ°Ð²ÐµÑÑÐ¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
      deal: 'Ð¡Ð¾Ð·Ð´Ð°ÑÑ ÑÐ´ÐµÐ»ÐºÑ',
      application: 'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½ÐºÐ¸',
      decisions: 'ÐÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ ÑÐµÑÐµÐ½Ð¸Ñ Ð±Ð°Ð½ÐºÐ¾Ð²',
    },
  },

  hotspots: {
    addClient: 'ÐÑÑÑÐ´Ð° Ð·Ð°Ð²Ð¾Ð´ÑÑ Ð½Ð¾Ð²Ð¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    filters: 'ÐÐ´ÐµÑÑ Ð¾ÑÐ±Ð¸ÑÐ°ÑÑ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð¿Ð¾ ÑÑÐ»Ð¾Ð²Ð¸ÑÐ¼',
    credit: 'ÐÐ´ÐµÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½ÐºÐ¸',
  },
};

export default ru;
